<script setup>
defineProps({
  addressHtml: { type: String, default: '' },
  phone: { type: String, default: '' },
  email: { type: String, default: '' },
  social: { type: Array, default: () => [] }
});

const phoneTel = (phone) => String(phone || '').replace(/\s/g, '');
</script>

<template>
  <div class="vsb-footer__column">
    <h3 class="vsb-footer__heading">Contactgegevens</h3>
    <ul class="vsb-footer__contact">
      <li class="vsb-footer__contact-item">
        <i class="fa fa-map-marker" aria-hidden="true"></i>
        <div>
          <strong>Adres:</strong><br />
          <span v-html="addressHtml"></span>
        </div>
      </li>
      <li v-if="phone" class="vsb-footer__contact-item">
        <i class="fa fa-phone" aria-hidden="true"></i>
        <div>
          <strong>Telefoon:</strong><br />
          <a :href="`tel:${phoneTel(phone)}`">{{ phone }}</a>
        </div>
      </li>
      <li v-if="email" class="vsb-footer__contact-item">
        <i class="fa fa-envelope" aria-hidden="true"></i>
        <div>
          <strong>Email:</strong><br />
          <a :href="`mailto:${email}`">{{ email }}</a>
        </div>
      </li>
    </ul>

    <div v-if="social.length" class="vsb-footer__social">
      <a
        v-for="item in social"
        :key="item.href"
        :href="item.href"
        target="_blank"
        rel="noopener noreferrer"
        class="vsb-footer__social-icon"
        :class="item.network"
        :aria-label="item.label"
      >
        <i :class="`fa fa-${item.icon}`" aria-hidden="true"></i>
      </a>
    </div>
  </div>
</template>
